import 'twin.macro';

import { Logo } from '@cheqroom/illustrations';
import { Heading, Illustration, Stack, Text } from '@cheqroom/ui';
import { ComponentProps, FC, ReactNode } from 'react';

export type AuthFlowHeaderProps = {
	heading: ReactNode;
	subheading?: ReactNode;
	headingAlign?: ComponentProps<typeof Heading>['align'];
	subheadingAlign?: ComponentProps<typeof Text>['align'];
	/** Preserve line breaks in subheading (`tw` must be static for twin.macro). */
	subheadingPreserveLineBreaks?: boolean;
	children?: ReactNode;
	spacing?: ComponentProps<typeof Stack>['spacing'];
};

/**
 * Auth flow intro: logo, page title, optional subheading, then optional extra content (e.g. banners).
 */
export const AuthFlowHeader: FC<AuthFlowHeaderProps> = ({
	children,
	heading,
	headingAlign = 'left',
	subheadingAlign = 'center',
	spacing = 'tight',
	subheading,
	subheadingPreserveLineBreaks,
}) => (
	<Stack align="center" vertical spacing={spacing}>
		<Illustration source={Logo} tw="mb-4" />
		<Heading tw="mt-0" element="h1" align={headingAlign}>
			{heading}
		</Heading>
		{subheading != null ? (
			subheadingPreserveLineBreaks ? (
				<Text align={subheadingAlign} tw="whitespace-pre-line">
					{subheading}
				</Text>
			) : (
				<Text align={subheadingAlign}>{subheading}</Text>
			)
		) : null}
		{children}
	</Stack>
);
